import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["selectOptions"],
    _excluded2 = ["field", "value", "onChange", "onClear", "initiallyAddSelectedFirst"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback, useEffect, useState } from 'react';
import findIndex from 'lodash/findIndex';
import findLast from 'lodash/findLast';
import { makeAsyncSelect } from '@atlaskit/select';
import ClearSelectedItemsButton from './clear-selection-button';
import MenuList from './menu-list';
import PaginationDetails from './pagination-details';
import { BaseSelect, selectComponents } from './select';
import ShowFullListButton from './show-full-list-button';
import { Footer } from './styled';
var MAX_TOTAL_COUNT = 1000; // To be cleaned up in EM-3568

var paginatedComponents = _objectSpread(_objectSpread({}, selectComponents), {}, {
  MenuList: MenuList
});

var ProxyBaseSelect = function ProxyBaseSelect(_ref) {
  var selectOptions = _ref.selectOptions,
      props = _objectWithoutProperties(_ref, _excluded);

  return selectOptions ? /*#__PURE__*/React.createElement(BaseSelect, _extends({}, props, {
    options: selectOptions
  })) : /*#__PURE__*/React.createElement(BaseSelect, props);
};

var AsyncSelect = makeAsyncSelect(ProxyBaseSelect);
/**
 * Adds option to the list of options if its value isn't currently in the Set of keys
 */

var addUniqueOptions = function addUniqueOptions(keys, options, option) {
  if (option.optionType === 'group') {
    var groupOptions = [];
    option.options.forEach(function (groupOption) {
      addUniqueOptions(keys, groupOptions, groupOption);
    });
    options.push(_objectSpread(_objectSpread({}, option), {}, {
      options: groupOptions
    }));
    return;
  } // Add single options:


  if (!keys.has(option.value)) {
    keys.add(option.value);
    options.push(option);
  }
};

var generateOptions = function generateOptions(selectedValues, newOptions, addSelectedFirst, previousOptions) {
  var optionKeys = new Set();
  var options = [];

  if (addSelectedFirst) {
    selectedValues.forEach(function (option) {
      addUniqueOptions(optionKeys, options, option);
    });
  }

  previousOptions === null || previousOptions === void 0 ? void 0 : previousOptions.forEach(function (option) {
    addUniqueOptions(optionKeys, options, option);
  });
  newOptions.forEach(function (option) {
    addUniqueOptions(optionKeys, options, option);
  });
  return options;
};

var getLastCursorOption = function getLastCursorOption(options) {
  return findLast(options, function (option) {
    return 'cursor' in option && !!option.cursor;
  });
}; // Needed to disable filtering from react-select


var noFilterOptions = function noFilterOptions() {
  return true;
};

var noLoadOptions = function noLoadOptions() {
  return Promise.resolve();
};

export var countSingleOptions = function countSingleOptions(options) {
  return options.map(function (option) {
    return option.optionType === 'group' ? option.options.length : 1;
  }).reduce(function (sumSoFar, count) {
    return sumSoFar + count;
  }, 0);
};
export var PaginatedAsyncSelectView = function PaginatedAsyncSelectView(_ref2) {
  var _field$pagination$ena, _field$pagination;

  var field = _ref2.field,
      value = _ref2.value,
      onChange = _ref2.onChange,
      onClear = _ref2.onClear,
      initiallyAddSelectedFirst = _ref2.initiallyAddSelectedFirst,
      restProps = _objectWithoutProperties(_ref2, _excluded2);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      page = _useState2[0],
      setPage = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isPaginationLoading = _useState6[0],
      setIsPaginationLoading = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      inputValue = _useState8[0],
      setInputValue = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      loadedOptions = _useState10[0],
      setLoadedOptions = _useState10[1];

  var _useState11 = useState((_field$pagination$ena = (_field$pagination = field.pagination) === null || _field$pagination === void 0 ? void 0 : _field$pagination.enableFullList) !== null && _field$pagination$ena !== void 0 ? _field$pagination$ena : false),
      _useState12 = _slicedToArray(_useState11, 2),
      enableFullList = _useState12[0],
      setEnableFullList = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      totalCount = _useState14[0],
      setTotalCount = _useState14[1];

  var _useState15 = useState({
    isError: false,
    error: null,
    onRetry: null
  }),
      _useState16 = _slicedToArray(_useState15, 2),
      error = _useState16[0],
      setError = _useState16[1];

  var getTotalCountWithFunctions = useCallback(function (newTotalCount) {
    var _field$pagination2, _field$pagination2$ke;

    if (newTotalCount === null || !((_field$pagination2 = field.pagination) !== null && _field$pagination2 !== void 0 && (_field$pagination2$ke = _field$pagination2.keywordValues) !== null && _field$pagination2$ke !== void 0 && _field$pagination2$ke.length)) {
      return newTotalCount;
    }

    var keywordValues = field.pagination.keywordValues;
    var newTotalCountWithKeywords = newTotalCount + value.filter(function (option) {
      return keywordValues.includes(option.value);
    }).length;
    return newTotalCountWithKeywords < MAX_TOTAL_COUNT ? newTotalCountWithKeywords : MAX_TOTAL_COUNT;
  }, [field, value]);
  var checkIfError = useCallback(function (search, options, onRetry) {
    if (options.some(function (option) {
      return option.optionType === 'error';
    })) {
      setError({
        isError: true,
        error: null,
        onRetry: onRetry
      });
      setIsLoading(false);
      return true;
    }

    setError({
      isError: false,
      error: null,
      onRetry: null
    });
    return false;
  }, []);
  var handleLoadOptions = useCallback(function (search) {
    var loadOptions = field.loadOptions;

    if (!loadOptions) {
      return;
    }

    setIsLoading(true);
    loadOptions(search, enableFullList, false, false, undefined, function (_ref3) {
      var options = _ref3.options,
          newTotalCount = _ref3.totalCount;

      if (checkIfError(search, options, function () {
        return handleLoadOptions(search);
      })) {
        return;
      }

      setLoadedOptions(generateOptions(value, options, initiallyAddSelectedFirst));
      setTotalCount(search ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
      setIsLoading(false);
    });
  }, [field, enableFullList, checkIfError, value, initiallyAddSelectedFirst, getTotalCountWithFunctions]);
  var handleShowMore = useCallback(function () {
    var showFullList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var isRetry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var loadOptions = field.loadOptions;

    if (!loadOptions) {
      return;
    }

    var originalLoadedOptions;

    if (showFullList) {
      originalLoadedOptions = [];
      setIsLoading(true);
    } else {
      originalLoadedOptions = loadedOptions;

      if (isRetry) {
        setIsLoading(true);
      } else {
        setIsPaginationLoading(true);
      }
    }

    loadOptions(inputValue, false, showFullList, true, getLastCursorOption(loadedOptions), function (_ref4) {
      var options = _ref4.options,
          newTotalCount = _ref4.totalCount;

      if (checkIfError(inputValue, options, function () {
        handleShowMore(showFullList, true);
      })) {
        return;
      }

      setPage(page + 1);
      setEnableFullList(false);
      setLoadedOptions(generateOptions(value, options, showFullList, originalLoadedOptions));
      setTotalCount(inputValue ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
      setIsPaginationLoading(false);
      setIsLoading(false);
    });
  }, [field, loadedOptions, inputValue, checkIfError, value, page, getTotalCountWithFunctions]);
  var handleShowFullList = useCallback(function () {
    handleShowMore(true, false);
  }, [handleShowMore]);
  var handleInputChange = useCallback(function (newInputValue) {
    var onInputChange = field.onInputChange;
    setEnableFullList(false);
    setPage(0);
    setInputValue(newInputValue);
    setTotalCount(null);
    setLoadedOptions([]);
    handleLoadOptions(newInputValue);
    onInputChange && onInputChange();
  }, [field, handleLoadOptions]);
  var handleOnChange = useCallback(function (options, action) {
    var selectData;

    if ('option' in action) {
      var actionOption = action.option;

      if (actionOption && 'value' in actionOption) {
        selectData = {
          selectedIndex: findIndex(loadedOptions, function (option) {
            return 'value' in option && option.value === actionOption.value;
          })
        };
      }
    }

    onChange === null || onChange === void 0 ? void 0 : onChange(options, action, selectData);
  }, [onChange, loadedOptions]); // We only want to call this on init, so it's ok to disable react-hooks/exhaustive-deps

  useEffect(function () {
    handleLoadOptions(''); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var loadedOptionsCount = totalCount === null ? 0 : countSingleOptions(loadedOptions);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AsyncSelect, _extends({
    cacheOptions: field.cacheOptions // @ts-ignore
    ,
    components: paginatedComponents,
    defaultOptions: field.defaultOptions,
    defaultOptionsLabel: field.defaultOptionsLabel,
    inputValue: inputValue // @ts-ignore
    ,
    loadOptions: noLoadOptions,
    onInputChange: handleInputChange,
    onMenuScrollToBottom: field.onMenuScrollToBottom,
    onMenuScrollToTop: field.onMenuScrollToTop,
    placeholder: field.placeholder,
    fieldKey: field.key,
    fieldLabel: field.label,
    fieldInvalidLabel: field.invalidLabel,
    selectOptions: loadedOptions,
    onFilterOption: noFilterOptions,
    menuListProps: {
      error: error,
      type: field.key,
      handleShowMore: handleShowMore,
      isLoading: isLoading,
      isPaginationLoading: isPaginationLoading,
      showShowMoreButton: totalCount !== null && loadedOptionsCount < totalCount
    },
    onChange: handleOnChange,
    value: value
  }, restProps)), field.pagination && !isLoading && !!(loadedOptions !== null && loadedOptions !== void 0 && loadedOptions.length) && !error.isError && /*#__PURE__*/React.createElement(Footer, null, !value.length && enableFullList && /*#__PURE__*/React.createElement(ShowFullListButton, {
    type: field.key,
    onShowFullList: handleShowFullList
  }), !!value.length && /*#__PURE__*/React.createElement(ClearSelectedItemsButton, {
    onClear: onClear,
    type: field.key
  }), !enableFullList && totalCount !== null && /*#__PURE__*/React.createElement(PaginationDetails, {
    itemsCount: loadedOptionsCount,
    totalCount: totalCount
  })));
};
export default PaginatedAsyncSelectView;